export default __webpack_public_path__ + "static/media/DesktopLine2.5aa88ff7.svg";